export const getCurrentIncomeMonthKey = (today = new Date()) => {
  const incomeMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return `${incomeMonth.getFullYear()}-${String(incomeMonth.getMonth() + 1).padStart(2, "0")}`;
};

export const monthKeyFromDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
};

const INCOME_PERIOD_MONTH_OVERRIDES = {
  // One-time IO correction: the 06/01/2026–11/09/2026 period belongs to Aug 2026.
  "2026-06-01": "2026-08",
};

const dateKey = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const getIncomePeriodStartMonthKey = (period = {}) => {
  const periodId = String(period.incomePeriodId || "");
  if (INCOME_PERIOD_MONTH_OVERRIDES[periodId]) {
    return INCOME_PERIOD_MONTH_OVERRIDES[periodId];
  }
  const explicitStart =
    period.startDatetime ||
    period.startDate ||
    period.incomePeriodStartDatetime;
  const explicitEnd =
    period.endDatetime || period.endDate || period.incomePeriodEndDatetime;
  if (
    dateKey(explicitStart) === "2026-01-06" &&
    dateKey(explicitEnd) === "2026-09-11"
  ) {
    return "2026-08";
  }
  if (explicitStart) return monthKeyFromDate(explicitStart);

  // IO encodes these period IDs as YYYY-DD-MM, matching the displayed start date.
  const encodedStart = periodId.match(
    /^(\d{4})-(\d{2})-(\d{2})$/,
  );
  return encodedStart ? `${encodedStart[1]}-${encodedStart[3]}` : "";
};

export const getIncomePeriodRatePolicy = (
  periods = [],
  month = "",
  fallbackOpenMonth = "",
) => {
  const latestClosedPeriod = periods[0] || {};
  const openMonth = monthKeyFromDate(
    latestClosedPeriod.endDatetime ||
    latestClosedPeriod.endDate ||
    latestClosedPeriod.incomePeriodEndDatetime,
  ) || fallbackOpenMonth;
  if (month && month === openMonth) return { isOpen: true, closedAt: null };

  const closedPeriod = periods.find(
    (period) => getIncomePeriodStartMonthKey(period) === month,
  );
  return {
    isOpen: false,
    closedAt:
      closedPeriod?.closedAt ||
      closedPeriod?.runDatetime ||
      closedPeriod?.endDatetime ||
      closedPeriod?.endDate ||
      closedPeriod?.incomePeriodEndDatetime ||
      null,
  };
};
